import React, { Component } from "react";
import "../../css/TempOrderErrorPopup.css";
import { lockBody, unlockBody } from "../../function/bodyLockStatus";
import { Translation } from "react-i18next";
import { connect } from "react-redux";

class TempOrderErrorPopup extends Component {
  componentDidMount() {
    lockBody();
  }
  componentWillUnmount() {
    unlockBody();
  }
  render() {
    const {
      closeTempOrderFailByOutOfStock,
      text,
      isResultPage,
      stockData,
      lang
    } = this.props;
    return (
      <div className="error-popup-background">
        <div className="error-popup-content">
          <div className="error-popup-head">
            <h2>{(text && text) || ""}</h2>
            <div
              className="close-button"
              onClick={closeTempOrderFailByOutOfStock.bind(this)}
            />
          </div>

          <div className="error-popup-body">
            {stockData && !isResultPage ? (
              <ul className="outOfStock_list">
                {stockData.map((data, i) => (
                  <li key={i}>{data.productName2}</li>
                ))}
              </ul>
            ) : null}

            <p className="error-body-text">
              <Translation>{t => <>{t("errorPopup.meanwhile")}</>}</Translation>
              ：
            </p>
            <div className="error-popup-grid">
              <div className="grid-left">
                <a
                  className="keep-shopping-a blockBtn grey"
                  href={
                    lang === "en" ? "/en/home" : "/tc/home " //點擊繼續購物回到首頁
                  }
                >
                  <Translation>
                    {t => <>{t("errorPopup.continueShopping")}</>}
                  </Translation>
                </a>
              </div>
              <div className="grid-right">
                <Translation>
                  {t => <>{t("errorPopup.futherAssistance")}</>}
                </Translation>
                <br />
                <Translation>{t => <>{t("errorPopup.hotline")}</>}</Translation>
                : +852-2192-3228
                <br />
                <Translation>{t => <>{t("errorPopup.email")}</>}</Translation>:
                <a href="mailto:eshop@emphasis.com" className="mail-to">
                  eshop@emphasis.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    myBagData: state.myBag.myBagData
  };
};
export default connect(mapStateToProps, null)(TempOrderErrorPopup);
